import projection from '../generated/pwh205f1.json';
import { AcceptanceManifest } from '../types';

/** Generated by scripts/build-acceptance-projections.js from the canonical Contract. */
export const pwh205f1AcceptanceManifest = projection as AcceptanceManifest;
